import { Link } from "react-router-dom";
import { NAV, CONTACT } from "@/data/content";
import { Logo } from "@/components/Header";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#05070D] border-t border-[#C5A059]/15 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo testId="footer-logo" />
            <p className="mt-6 max-w-sm text-slate-400 leading-relaxed text-sm">
              Bespoke, 100% drug-free trauma recovery and Post-Traumatic Growth for high-performing individuals. Delivered confidentially worldwide.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} data-testid={`footer-link-${n.id}`} className="text-sm text-slate-300 hover:text-white link-underline">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Locations</p>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>No. 2 Harley Street<br />London</li>
              <li>Mountain Retreat<br />Andalusia, Spain</li>
              <li>Online &amp; Private Residence<br />Worldwide</li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Confidential Contact</p>
            <ul className="space-y-3 text-sm text-slate-300">
              <li data-testid="footer-phone">{CONTACT.phone}</li>
              <li data-testid="footer-email">{CONTACT.email}</li>
              <li className="text-red-300" data-testid="footer-triage">Immediate support: {CONTACT.triage}</li>
            </ul>
          </div>
        </div>
        <div aria-hidden className="mt-20 font-display text-outline leading-none select-none text-[22vw] lg:text-[15rem] tracking-tight -mb-6 lg:-mb-12">
          Habitreat
        </div>
        <div className="mt-6 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} Habitreat. All rights reserved.</span>
          <span className="font-data tracking-widest uppercase">Drug-free · Root-cause · PTG</span>
        </div>
      </div>
    </footer>
  );
}
